/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

import { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { I18nConsumer } from 'automation-ui-i18n/I18nContext';
import { I18nProviderShape } from 'automation-ui-i18n/propTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function wireLazyLangLoaderDecorator(translationYamlFiles = []) {
  return WrappedComponent => {
    class LazyLangLoaderDecorator extends Component {
      constructor(...args) {
        super(...args);
        this.state = {
          areLangStringsLoading: translationYamlFiles.every(file =>
          // Initialize the state with false if the lang strings are all loaded
          {
            return !Object.prototype.hasOwnProperty.call(this.props.I18nProvider.langRegistry, file.source);
          })
        };
        this._isUnmounted = false;
      }
      componentDidMount() {
        const langAvailablePromise = Promise.all(translationYamlFiles.map(translationFile => this.props.I18nProvider.register(translationFile)));
        langAvailablePromise.then(() => {
          if (this._isUnmounted) {
            return;
          }
          this.setState({
            areLangStringsLoading: false
          });
        });
      }
      componentWillUnmount() {
        this._isUnmounted = true;
      }
      render() {
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
          areLangStringsLoading: this.state.areLangStringsLoading
        }, this.props));
      }
    }
    LazyLangLoaderDecorator.propTypes = {
      I18nProvider: I18nProviderShape.isRequired
    };
    LazyLangLoaderDecorator.defaultProps = WrappedComponent.defaultProps;
    LazyLangLoaderDecorator.displayName = `LazyLangLoader(${getComponentName(WrappedComponent)})`;
    attachWrappedComponent(LazyLangLoaderDecorator, WrappedComponent);
    return props => /*#__PURE__*/_jsx(I18nConsumer, {
      children: context => /*#__PURE__*/_jsx(LazyLangLoaderDecorator, Object.assign({}, props, {
        I18nProvider: context
      }))
    });
  };
}